import isArray from "lodash/isArray";
import isNumber from "lodash/isNumber";
import isPlainObject from "lodash/isPlainObject";
import isString from "lodash/isString";


export default (configs, patternId, patternConfig) => {
  const { index, spacingIndex } = patternConfig;
//  const { index } = patternConfig;
  const config = configs[patternId];
  let sum;

  if (!index) {
    sum = Object.keys(patternConfig).reduce((acc, k) => {
      acc += patternConfig[k] ? 1 : 0;
      return acc;
    }, 0);
  }
  /*

console.log("index :" + index);
console.log("spacingIndex :" + spacingIndex);
console.log("---------");
console.log("config :" + config);

console.log("config[index][spacingIndex] :" + config[0][1]);
*/
//console.log (patternConfig);


  if (isNumber(config)) {
    return config || "--";
  } else if (isString(config)) {
    return config || "--";
  } else if (isArray(config)) {
    return config[index || sum] || "--";
  } else if (isPlainObject(config)) {
    return config[index][spacingIndex] ? config[index][spacingIndex] : "--"
  } else {
    console.log("pattern ratio not found");
    return "--";
  }

};



// WEBPACK FOOTER //
// ./src/utils/getPatternRatio.js